/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StoresCashbackRatesContainerQueryVariables = {|
  storeIdEq: string,
  afterDate: any,
  beforeDate: any,
|};
export type StoresCashbackRatesContainerQueryResponse = {|
  +brand: ?{|
    +id: string,
    +name: string,
    +defaultCashbackRates: $ReadOnlyArray<{|
      +startDate: any,
      +endDate: any,
      +rate: number,
      +state: string,
    |}>,
    +birthdayCashbackRates: $ReadOnlyArray<{|
      +startDate: any,
      +endDate: any,
      +rate: number,
      +state: string,
    |}>,
  |}
|};
export type StoresCashbackRatesContainerQuery = {|
  variables: StoresCashbackRatesContainerQueryVariables,
  response: StoresCashbackRatesContainerQueryResponse,
|};
*/


/*
query StoresCashbackRatesContainerQuery(
  $storeIdEq: ID!
  $afterDate: Date!
  $beforeDate: Date!
) {
  brand: store(id: $storeIdEq) {
    id
    name
    defaultCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
      startDate
      endDate
      rate
      state
    }
    birthdayCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
      startDate
      endDate
      rate
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIdEq",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "beforeDate",
    "type": "Date!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "afterDate",
    "variableName": "afterDate"
  },
  {
    "kind": "Variable",
    "name": "beforeDate",
    "variableName": "beforeDate"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": "brand",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeIdEq"
      }
    ],
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CashbackRate",
        "kind": "LinkedField",
        "name": "defaultCashbackRates",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CashbackRate",
        "kind": "LinkedField",
        "name": "birthdayCashbackRates",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoresCashbackRatesContainerQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoresCashbackRatesContainerQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "StoresCashbackRatesContainerQuery",
    "operationKind": "query",
    "text": "query StoresCashbackRatesContainerQuery(\n  $storeIdEq: ID!\n  $afterDate: Date!\n  $beforeDate: Date!\n) {\n  brand: store(id: $storeIdEq) {\n    id\n    name\n    defaultCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {\n      startDate\n      endDate\n      rate\n      state\n    }\n    birthdayCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {\n      startDate\n      endDate\n      rate\n      state\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd1084004a5cd7770aa33f905390d723b';

module.exports = node;
